import { ErrorReason } from './errorMessages';

export const verificationErrorToReason = (error: any): ErrorReason => {
    const code = error?.response?.status;

    switch (code) {
        case 401:
        case 404:
            return 'invalid-code';
        case 422:
            return 'sms-unsupported';
        case 429:
            return 'too-many-attempts';
        case 423:
            return 'phone-blocked';
        case 500:
            return 'server-error';
        default:
            return error.code === 'ERR_NETWORK' ? 'network-error' : 'unknown';
    }
};
